












































import { Component, Vue, Prop } from "vue-property-decorator";
import { BIcon, BIconXCircle, BIconUpload } from "bootstrap-vue";
@Component({
  components: {
    BIcon,
    BIconUpload,
    BIconXCircle,
  },
})
export default class Pdf extends Vue {
  @Prop() protected readonly galeryPdf!: {
    PdfLink: string;
    PdfDownload: string;
    TxtPdf: string;
  }[];
}
